import { Environments, PaySafeEnvironments } from '@monorepo/client-types';
import { Application } from '@monorepo/types';
import {
  CoralogixDomain,
  CoralogixOtelWebOptionsInstrumentations,
} from '@coralogix/browser';

export enum EnvKeys {
  PROJECT = 'VITE_PROJECT',
  APP_ENV = 'VITE_APP_ENV',
  API_END_POINT = 'VITE_API_END_POINT',
  PUSHER_API_KEY = 'VITE_PUSHER_API_KEY',
  PUSHER_CLUSTER = 'VITE_PUSHER_CLUSTER',
  LEADDYNO_PUBLIC_KEY = 'VITE_LEADDYNO_PUBLIC_KEY',
  AWS_REGION = 'VITE_AWS_REGION',
  COGNITO_POOL_NAME = 'VITE_COGNITO_POOL_NAME',
  AWS_CLIENT_ID = 'VITE_AWS_CLIENT_ID',
  CDN_BASE_URL = 'VITE_CDN_BASE_URL',
  DOMAIN_NAME = 'VITE_DOMAIN_NAME',
  CLOUDINARY_FOLDER = 'VITE_CLOUDINARY_FOLDER',
  SENTRY_DSN = 'VITE_SENTRY_DSN',
  GTM_ID = 'VITE_GTM_ID',
  MIXPANEL_TOKEN = 'VITE_MIXPANEL_TOKEN',
  MIXPANEL_API_HOST = 'VITE_MIXPANEL_API_HOST',
  AWS_USER_POOL_DOMAIN = 'AWS_USER_POOL_DOMAIN',
  RECAPTCHA_SITE_KEY = 'VITE_RECAPTCHA_SITE_KEY',
  GA_ID = 'VITE_GA_ID',
  PAYSAFE_PUBLIC_KEY = 'VITE_PAYSAFE_PUBLIC_KEY',
  PAYSAFE_ENV = 'VITE_PAYSAFE_ENV',
  FEATURE_FLAG_API_HOST = 'VITE_FEATURE_FLAG_API_HOST',
  FEATURE_FLAG_CLIENT_KEY = 'VITE_FEATURE_FLAG_CLIENT_KEY',
  S3_BASE_URL = 'VITE_S3_BASE_URL',
  S3_BASE_ENABLED = 'VITE_S3_BASE_ENABLED',
  HUB_NEXT_BASE_URL = 'VITE_HUB_NEXT_URL',
  FF_CACHE_INTERVAL = 'VITE_FF_CACHE_INTERVAL',
  CORALOGIX_RUM_PUBLIC_KEY = 'VITE_CORALOGIX_RUM_PUBLIC_KEY',
  CORALOGIX_RUM_DOMAIN = 'VITE_CORALOGIX_RUM_DOMAIN',
  CORALOGIX_RUM_INSTR_ERRORS = 'VITE_CORALOGIX_RUM_INSTR_ERRORS',
  CORALOGIX_RUM_INSTR_FETCH = 'VITE_CORALOGIX_RUM_INSTR_FETCH',
  CORALOGIX_RUM_INSTR_XHR = 'VITE_CORALOGIX_RUM_INSTR_XHR',
  CORALOGIX_RUM_INSTR_CUSTOM = 'VITE_CORALOGIX_RUM_INSTR_CUSTOM',
  CORALOGIX_RUM_INSTR_LONG_TASKS = 'VITE_CORALOGIX_RUM_INSTR_LONG_TASKS',
  CORALOGIX_RUM_INSTR_RESOURCES = 'VITE_CORALOGIX_RUM_INSTR_RESOURCES',
  CORALOGIX_RUM_INSTR_INTERACTIONS = 'VITE_CORALOGIX_RUM_INSTR_INTERACTIONS',
  CORALOGIX_RUM_INSTR_WEB_VITALS = 'VITE_CORALOGIX_RUM_INSTR_WEB_VITALS',
  VERSION = 'VITE_VERSION',
}

export interface Environment {
  apiEndPoint: string;
  pusherApiKey: string;
  pusherCluster: string;
  domainName: string | undefined;
  leaddynoPublicKey: string;
  awsRegion: string;
  awsClientId: string;
  cognitoPoolName: string;
  cdnBaseUrl: string;
  cloudinaryFolder: string;
  appEnv: Environments;
  application: Application;
  sentryDsn: string;
  gtmId: string;
  mixPanelToken: string;
  mixPanelApiHost: string;
  awsUserPoolDomain: string;
  recaptchaSiteKey: string;
  gaId: string;
  isProduction: boolean;
  s3BaseUrl: string;
  featureFlagApiUrl: string;
  featureFlagClientKey: string;
  paysafePublicKey: string;
  paysafeEnv: PaySafeEnvironments;
  hubNextBaseUrl: string;
  ffCacheInterval: number;
  coralogixRumPublicKey: string;
  coralogixRumDomain: CoralogixDomain;
  coralogixRumInstrumentations: CoralogixOtelWebOptionsInstrumentations;
  version: string;
}
